export const confirmPromptConstants = {
    SHOW: 'Confirm_Prompt_SHOW',
    HIDE: 'Confirm_Prompt_HIDE'
};
